const departementTypes = {
    SAVE_DEPARTEMENT: 'SAVE_DEPARTEMENT',
    GET_DEPARTEMENTS: 'GET_DEPARTEMENTS',
    SET_DEPARTEMENTS: 'SET_DEPARTEMENTS',
    UPDATE_DEPARTEMENT: 'UPDATE_DEPARTEMENT',
    DELETE_DEPARTEMENT: 'DELETE_DEPARTEMENT'
};

export default departementTypes;
